// extracted by mini-css-extract-plugin
module.exports = {"container":"CreditOffer_container__b6kI3","message":"CreditOffer_message__Axyd0"};